<template>
  <generic-container
    :title="$t('messages')"
    icon="envelope up outline"
    :show_back="true"
    :header_buttons="header_buttons"
  >
    <table
      class="ui blue very compact celled striped selectable table"
      ref="table"
      style="width: 100%"
    >
      <thead>
        <tr>
          <th>{{ $t("name") }}</th>
          <th>{{ $t("dates") }}</th>
          <th>{{ $t("addressee") }}</th>
          <th>{{ $t("status") }}</th>
          <th>{{ $t("args") }}</th>
          <th>{{ $t("options") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <message-modal ref="message_modal" @success="refresh" />
    <message-info-modal ref="message_info_modal" />
  </generic-container>
</template>

<script>
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import MessageModal from "./message_modal/Index.vue";
import MessageInfoModal from "./message_info_modal/Index.vue";
import {
  init_ajax_data_datables,
  enterprise_setup,
  local_api,
  error_toast,
  success_toast,
} from "@/utils";
import { truncate } from "lodash";

export default {
  name: "OutboxMessages",
  components: {
    "generic-container": GenericContainer,
    MessageModal,
    MessageInfoModal,
  },
  data() {
    return {
      header_buttons: [
        {
          icon: "refresh",
          tooltip: this.$t("refresh"),
          click: this.refresh,
        },
        {
          icon: "blue add",
          tooltip: this.$t("add"),
          click: this.add,
        },
      ],
      datatable: {},
      template_uuid: "",
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    translated_status(status_code) {
      let vm = this;
      switch (status_code) {
        case "S":
          return vm.$t("sent");
        case "U":
          return vm.$t("unsent");
        case "E":
          return vm.$t("errored");
        default:
          return status_code;
      }
    },
    refresh() {
      this.init();
    },
    init() {
      let vm = this;
      let columns = [
        {
          data: function (row) {
            return row.name;
          },
        },
        {
          data: function (row) {
            let send_date = filters.formatDate(
              row.programmed_send_date,
              vm.enterprise_setup.detailed_date_format,
            );
            let create_date = filters.formatDate(
              row.create_date,
              vm.enterprise_setup.detailed_date_format,
            );
            return `<div class="ui list"><div class="item">${vm.$t(
              "created",
            )}: <b>${create_date}</b></div><div class="item">${vm.$t(
              "send",
            )}: <b>${send_date}</b></div></div>`;
            // return `<div class="ui list"><div class="item"><i class="blue circle icon" /> ${create_date}</div><div class="item"><i class="green envelope icon" />${send_date}</div></div>`;
          },
        },
        {
          data: function (row) {
            return row.setup.addressee;
          },
        },
        {
          data: function (row) {
            return vm.translated_status(row.status_code);
          },
        },
        {
          data: function (row) {
            if (row.setup.message_args) {
              let list = row.setup.message_args.reduce((prev, curr) => {
                return `${prev}<div class="item">${curr.name}:${truncate(
                  curr.default_value,
                  {
                    length: 75,
                  },
                )}</div>`;
              }, "");
              return `<div class="ui list">${list}</div>`;
            } else return "";
          },
        },
        {
          data: function (row) {
            return `<div class="ui orange mini icon button" data-uuid="${row.uuid}" onclick="window.jQuery(window).trigger('modul.edit_message', this);"><i class="write icon"></i></div><div class="ui red mini icon button" data-uuid="${row.uuid}" onclick="window.jQuery(window).trigger('modul.delete_message', this);"><i class="trash icon"></i></div><div class="ui blue mini icon button" data-uuid="${row.uuid}" onclick="window.jQuery(window).trigger('modul.message_info', this);"><i class="info icon"></i></div>`;
          },
        },
      ];

      let onSelect = () => {
        // console.log(data);
        // vm.$refs.outbox_modal.show_modal(data);
      };
      let onCreatedRow = () => {};
      let transform = (data) => {
        data.search.template_uuid = vm.template_uuid;
      };

      vm.datatable = init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["outbox message url"],
        columns,
        onSelect,
        onCreatedRow,
        transform,
      );
    },
    add() {
      let vm = this;
      vm.$refs.message_modal.show_modal({ template_uuid: vm.$route.query.i });
    },
  },
  created() {
    let vm = this;
    window.jQuery(window).on("modul.edit_message", function (e, element) {
      let uuid = window.jQuery(element).data("uuid");
      vm.$refs.message_modal.show_modal({
        message_uuid: uuid,
      });
    });

    window.jQuery(window).on("modul.delete_message", function (e, element) {
      let uuid = window.jQuery(element).data("uuid");
      vm.$alertify.confirm(
        vm.$t("are you sure to remove message?"),
        function () {
          local_api(vm, "post", "/outbox/message/do-remove", {
            u: uuid,
          })
            .then(() => {
              success_toast(vm.$t("message deleted"));
              vm.init();
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    });

    window.jQuery(window).on("modul.message_info", function (e, element) {
      let uuid = window.jQuery(element).data("uuid");
      vm.$refs.message_info_modal.show_modal(uuid);
    });
  },
  mounted() {
    let vm = this;
    vm.template_uuid = vm.$route.query.i;
    vm.init();
  },
};
</script>
